import { request } from '../request';

/**
 * 获取首页概览数据
 *
 * @returns 首页概览数据
 */
export const fetchGetDashboardData = (params?: any) => {
  return request<any>({
    url: '/finance/dashboard/',
    method: 'get',
    params
  });
};

/**
 * 获取收入趋势数据
 *
 * @param params
 * @returns
 */
export const fetchGetIncomeTrendData = (params: any) => {
  return request<any>({
    url: '/finance/dashboard/curve/',
    method: 'get',
    params
  });
};

/**
 * 获取用水TOP数据
 *
 * @param params
 * @returns
 */
export const fetchGetWaterTopData = (params: any) => {
  return request<any>({
    url: '/finance/dashboard/water-usage/',
    method: 'get',
    params
  });
};

export const fetchGetDeviceIncomeTrendData = (params: any) => {
  return request<any>({
    url: '/finance/dashboard/device-revenue/',
    method: 'get',
    params
  });
};

/**
 * 获取用水趋势数据
 *
 * @param params
 * @returns
 */
export const fetchGetWaterUseTrendData = (params: any) => {
  return request<any>({
    url: '/finance/dashboard/timeseries/',
    method: 'get',
    params
  });
};

export const fetchGetBalance = (params?: any) => {
  return request<any>({
    url: '/finance/balance/',
    method: 'get',
    params
  });
};
